module.exports = __webpack_public_path__ + "img/livePreviw.e7f06b25.jpg";